import axios from 'axios'
import { message } from 'ant-design-vue'
import { useAuthStore } from '../store/auth'
import { redirectToLogin } from '../utils/authRedirect'
import i18n from '../plugins/i18n'
import { ERROR_CODE_MAP, KNOWN_ERROR_CODES } from '@/config/errorCodes'

const baseURL = import.meta.env.DEV ? '/api' : import.meta.env.VITE_API_BASE || ''

const http = axios.create({
  baseURL,
  withCredentials: true,
})
// 添加请求拦截器
http.interceptors.request.use(
  (config) => {
    config.headers['X-CSRF-Token'] = sessionStorage.getItem("csrf");
    config.headers['x-jwt'] = '' + sessionStorage.getItem("jwt");
    config.headers['x-locals'] = localStorage.getItem("language") == "China" ? "zh" : "en";
    const isFormDataRequest =
      config.data instanceof FormData ||
      config.url.indexOf("/api/v1/upload") > -1 ||
      config.url.indexOf("/api/v1/compute/file/upload") > -1 ||
      config.url.indexOf("/api/v1/compute/file/uploadByOrg") > -1 ||
      config.url.indexOf("/api/v1/pointCloud/project/uploadImg") > -1;
    // 原有业务逻辑：特定接口修改 Content-Type
    if (isFormDataRequest) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else if (config.url.indexOf("/marker_info/add") > -1) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    } else {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    // 本地开发环境取消鉴权
    // if (process.env.NODE_ENV === "development") {
    //   config.headers.debug = "debug";
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error?.response?.status
    const suppressErrorMessage = Boolean(error?.config?.suppressErrorMessage)

    // 获取服务端返回的错误信息
    const responseCode = error?.response?.data?.code
    const responseMsg = error?.response?.data?.msg || error?.response?.data?.message

    // 优先使用错误码映射的多语言提示
    let errorMessage
    if (responseCode && KNOWN_ERROR_CODES.has(Number(responseCode))) {
      const i18nKey = ERROR_CODE_MAP[responseCode]
      errorMessage = i18n.global.t(i18nKey)
      console.log(`[Error Code ${responseCode}] ${i18nKey} -> ${errorMessage}`)
    } else {
      // 未知错误码，使用服务端返回的消息或默认提示
      errorMessage = responseMsg || i18n.global.t('common.requestFailed')
    }

    if (status === 401) {
      const authStore = useAuthStore()
      authStore.clearAuthState()
      if (!authStore.shouldSuppressAuthRedirect) {
        await redirectToLogin()
      }
    } else if (!suppressErrorMessage) {
      message.error(errorMessage)
    }
    return Promise.reject(error)
  }
)

const get = async (url, config) => {
  const res = await http.get(url, config)
  return res.data
}

const post = async (url, data, config) => {
  const res = await http.post(url, data, config)
  return res.data
}

const put = async (url, data, config) => {
  const res = await http.put(url, data, config)
  return res.data
}

const del = async (url, config) => {
  const res = await http.delete(url, config)
  return res.data
}

const download = async (url, config) => {
  const res = await http.get(url, { ...config, responseType: 'blob' })
  return res
}

export const request = { get, post, put, delete: del, download }

export default http
